import { useFetchAllVariablesQuery } from '@redux/api/variables.api'

import { ENTITY_TYPES_REQUEST } from '@constants'

type TProps = {
  formId?: string | number
  contextMenuId?: string | number
  windowId?: string | number
  id?: string | number
  type?: ENTITY_TYPES_REQUEST
  isFetchAllVariables?: boolean
}

export const useVariables = ({ id, type, isFetchAllVariables }: TProps) => {
  const { data: variables } = useFetchAllVariablesQuery(
    {
      viewType: type,
      id,
    },
    !isFetchAllVariables ? { skip: !id, refetchOnMountOrArgChange: true } : undefined
  )

  return variables || []
}
